"use client";

import {useState} from "react";
import Link from "next/link";
import styles from "./styleDropdown.module.scss";
import stylesMainMenu from "../styleMenu.module.scss"
import { FaArrowRightLong } from "react-icons/fa6";
import LocalizedLinkClient from "../../LocalizedLink/LocalizedLinkClient";

export default function MenuDropdown({label, sections, href, prefetch = true}) {
    const [open, setOpen] = useState(false);
    const hasSections = Array.isArray(sections) && sections.length > 0;

    if (!hasSections) {
        return (
            <LocalizedLinkClient
                href={href}
                className={stylesMainMenu.menuLinks}
                prefetch={prefetch}> {label} </LocalizedLinkClient>
        );
    }

    return (
        <div className={styles.dropdownContainer}
             onMouseEnter={() => setOpen(true)}
             onMouseLeave={() => setOpen(false)}>
            <Link href={href} className={styles.trigger} onClick={() => setOpen(false)} >{label}</Link>
            {open && (
                <div className={styles.dropdownWrapper}>
                    <span className={styles.triangle}></span>
                    <div className={styles.dropdown}>
                        <div className={styles.content}>
                            {sections.map((section, i) => (
                                <div key={i} className={styles.section}>
                                    {section.title && (
                                        section.titleHref ? (
                                            <LocalizedLinkClient
                                                href={section.titleHref}
                                                onClick={() => setOpen(false)}
                                                prefetch={section.titlePrefetch !== undefined ? section.titlePrefetch : true}
                                                className={`${styles.sectionTitle} ${styles.sectionTitleLink}`}>
                                                {section.title}
                                            </LocalizedLinkClient>
                                        ) : (
                                            <div className={styles.sectionTitle}>{section.title}</div>
                                        )
                                    )}
                                    {section.links.map((link, j) => (
                                        <LocalizedLinkClient
                                            key={j}
                                            href={link.href}
                                            onClick={() => setOpen(false)}
                                            prefetch={link.prefetch !== undefined ? link.prefetch : true}
                                            className={styles.linkAnchor}>
                                                <span className={styles.linkLabel}>{link.label}</span>
                                                <FaArrowRightLong className={styles.arrow} aria-hidden />
                                        </LocalizedLinkClient>
                                    ))}
                                    {i < sections.length - 1 && <hr className={styles.divider}/>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}